import { KeyMapper } from '@/modules/_shared/audit-log/types'

const KEY_MAPPER = {
    name: 'Name',
    email: 'Email',
    roles: 'Roles'
}

export function mapper (override: KeyMapper = {}): KeyMapper {
    return {
        ...KEY_MAPPER,
        ...override
    }
}
